import { PostPreview } from '../postPreview'
import { ButtonCreate } from '../buttonCreate'
import { useClube } from '../contextClube'
import { SpaceLoader } from '../../../../loaders/spaceLoader'
import { toast } from 'react-toastify';
import { api } from '../../../../../services/api';

import { Container } from './style';


export function SecondaryBanners() {
    const { 
        secondaryBanners, 
        setModalTitleAndRoute, 
        loading, 
        deleteElement 
    } = useClube()

    function handleClickCreateButton() {
        setModalTitleAndRoute({title: 'Banner Secundário', route: '/createSecondaryBanner', create: 1})
    }

    function handleClickEditButton() {
        setModalTitleAndRoute({title: 'Banner Secundário', route: '/updateSecondaryBanner', create: 0})
    }

    async function handleClickActiveButton(id, status) {
        const obj = {
            id,
            active: status
        }

        try{
            await api.patch('/activeSecondaryBanner', obj,  {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }catch{
            toast.error('Algo deu errado, tente novamente')
        }
    }

    async function handleClickToDelete(id) {
        try{
            const response = await api.delete(`/deleteSecondaryBanner/${id}`,  {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            const { success, message } = response.data

            if(success){
                toast.success(message)
                deleteElement('/deletePrimaryBanner', id)
            }
            else
                throw new Error(message)

        }catch(error){
            toast.error(error.message)
        }
    }

    return(
        <Container>
            <div className="title">
                <h2>Banners Secundários</h2>
                <div />
            </div>

            {
                loading ?
                    <SpaceLoader colorLoader="#535352"/>
                :
                secondaryBanners.map(banner => (
                    <PostPreview 
                        key={banner.id}
                        datas={banner}
                        handleClickEditButton={handleClickEditButton}
                        handleClickActiveButton={handleClickActiveButton}
                        handleClickToDelete={handleClickToDelete}
                    />
                ))
            }
            
            <ButtonCreate 
                handleClickCreateButton={handleClickCreateButton}
            />
        </Container>
    )
}
